import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchRolePermissions = createAsyncThunk('permissions/fetch', async () => {
  const { data } = await client.get('/auth/role-permissions/');
  return data;
});

export const saveRolePermissions = createAsyncThunk('permissions/save', async (matrix, { rejectWithValue }) => {
  try {
    await client.put('/auth/role-permissions/update/', matrix);
    return matrix;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: { matrix: {}, loading: false, saving: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRolePermissions.pending, (state) => { state.loading = true; })
      .addCase(fetchRolePermissions.fulfilled, (state, action) => { state.loading = false; state.matrix = action.payload; })
      .addCase(saveRolePermissions.pending, (state) => { state.saving = true; })
      .addCase(saveRolePermissions.fulfilled, (state, action) => { state.saving = false; state.matrix = action.payload; })
      .addCase(saveRolePermissions.rejected, (state) => { state.saving = false; });
  },
});

export default permissionsSlice.reducer;
